import type { ResAllType } from '../../Types/Api/All'
import type { LeadType } from '../../Types/Api/Lead'
import type { OKRes } from '../../Types/Api/Ok'
import { api } from './API'
import { isResErrorType, requireAuth } from './Auth'

export const findLists = async (page: number, id: number) => {
  const res = await requireAuth<LeadType>(api.get(`lists/${id}`, { page }))

  if (!res.ok || !res.data || isResErrorType(res.data)) {
    return res
  }

  return res
}

export const searchLeadsForList = async (
  page: number,
  conditions = {},
  filter_groups = {},
) => {
  const res = await requireAuth<ResAllType<LeadType>>(
    api.get(`leads`, {
      page,
      conditions,
      filter_groups: JSON.stringify(filter_groups),
    }),
  )

  if (!res.ok || !res.data || isResErrorType(res.data)) {
    return res
  }

  return {
    ...res,
    data: {
      ...res.data,
      data: res.data.data.map((lead) => ({
        ...lead,
      })),
    },
  }
}

export const store = async (name: string, type: string, filter_groups = {}) => {
  const res = await requireAuth<LeadType>(
    api.post(`lists`, { name, type, filter_conditions: filter_groups }),
  )

  if (!res.ok || !res.data || isResErrorType(res.data)) {
    return res
  }

  return res
}

export const getLists = async (page: number) => {
  const res = await requireAuth<ResAllType<LeadType>>(
    api.get(`lists`, { page }),
  )

  if (!res.ok || !res.data || isResErrorType(res.data)) {
    return res
  }

  return {
    ...res,
    data: {
      ...res.data,
      data: res.data.data.map((list) => ({
        ...list,
      })),
    },
  }
}

export const destroyList = async (id: number) => {
  const res = await requireAuth<OKRes>(api.delete(`lists/${id}`))
  return res
}

export const updateList = async (data: {
  id: number
  name: string
  type: string
  filter_conditions: any
  display_field_orders: [string]
}) => {
  const res = await requireAuth<OKRes>(api.put(`lists/${data.id}`, { ...data }))
  return res
}

export const csvDownloadForList = async (id: number, display_settings: any) => {
  const res = await requireAuth<string>(
    api.post('lists/csvDownload', {
      id: id,
      display_settings: JSON.stringify(display_settings),
    }),
  )

  if (!res.ok || !res.data || isResErrorType(res.data)) {
    return res
  }

  const fileName = 'リード一覧.csv'
  const bom = new Uint8Array([0xef, 0xbb, 0xbf])
  const file = new Blob([bom, res.data], { type: 'text/csv;charset=utf-8' })

  const dlBtn = document.createElement('a')
  dlBtn.download = fileName
  dlBtn.href = URL.createObjectURL(file)
  dlBtn.click()

  return res
}
